import Player from "./Player";
import {IFrameComponent} from "./components/IFrameComponent";
import Vimeo from '@vimeo/player';


export default class VimeoPlayer extends Player {
    iFrame;

    init() {
        this.addIframe()
        super.init();
    }

    addIframe() {
        const vimeoSource = this.getSource()
        this.registerComponent('IFrameComponent', IFrameComponent)
        this.addChildComponent('IFrameComponent', {
            source: vimeoSource
        })
        document.getElementById('corsi-player_html5_api').style.display = "none"
    }
    
    configurePlayable() {
        const iframe = document.querySelector('#corsi-video-vimeo-iframe');
        this.playable = new Vimeo(iframe);
    }   
    
    updateVideoSrc(src) {
        // do nothing for vimeo
    }

    setCurrentTime(seconds) {
        this.playable.setCurrentTime(seconds)
    }

    unmute() {
        this.playable.setVolume(1)
    }

    setOnTimeUpdate() {
        this.playable.on('timeupdate', (data) => {
            this.onTimeUpdate(data.seconds)
        })
    }
}
